import { BaseReducer } from '@hobs/utils/baseReducer';
import {
  FORSUBMIT,
  UNITS,
  GET,
  UNITS_CURRENT,
  CURRENT,
  GET_PARTY_EXERCISES
} from '@hobs/constants/parties';

class Parties extends BaseReducer {
  static defaultState = {
    partyCreateForSubmit: {},
    party: null,
    partyUnits: null,
    assignedPartyUnits: null,
    currentParty: null,
    exercises: null
  };

  constructor() {
    super(Parties.defaultState);

    this.actionMap = {
      [FORSUBMIT.SUCCESS]: this.getPartyCreateForSubmit,
      [GET.SUCCESS]: this.getParty,
      [UNITS.SUCCESS]: this.getPartyUnits,
      [UNITS_CURRENT.SUCCESS]: this.getAssignedPartyUnits,
      [CURRENT.SUCCESS]: this.getCurrentParty,
      [GET_PARTY_EXERCISES.SUCCESS]: this.getPartyExercises
    };
  }

  getPartyCreateForSubmit = (state, action) => {
    return Object.assign({}, state, {
      partyCreateForSubmit: action.response
    });
  };

  getParty = (state, action) => {
    return Object.assign({}, state, {
      party: action.response
    });
  };

  getPartyUnits = (state, action) => {
    return Object.assign({}, state, {
      partyUnits: action.response
    });
  };

  getAssignedPartyUnits = (state, action) => {
    return Object.assign({}, state, {
      assignedPartyUnits: action.response
    });
  };

  getCurrentParty = (state, action) => {
    return Object.assign({}, state, {
      currentParty: action.response
    });
  };

  getPartyExercises = (state, action) => {
    return Object.assign({}, state, {
      exercises: action.response
    });
  };
}
export default new Parties().reducer;
